import { render, staticRenderFns } from "./GrapeJSEditor.vue?vue&type=template&id=4f3cf252&"
import script from "./GrapeJSEditor.vue?vue&type=script&lang=js&"
export * from "./GrapeJSEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports